import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=e07cc390&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=e07cc390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07cc390",
  null
  
)

export default component.exports